import axios from "axios";
import { baseUrl } from "../Common/Constants";
import { AxiosRequestConfig } from "axios";
import httpClient from "../Core/http";



class PartwearoutApi {

    fetchUniqueAssemblys(){
        let url = "partwearout/uniqueAssemblys";
        return new Promise((resolve, reject) => {
            httpClient
                .get<any>(url, { })
                .then((response: any) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }
    fetchUniqueComponents(params: any, signal: any): Promise<any> {
        let url = "partwearout/uniqueComponents";
        return new Promise((resolve, reject) => {
            httpClient
                .get<any>(url, { params: params, signal: signal })
                .then((response: any) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }
    fetchUniqueDescriptions(params: any, signal: any): Promise<any> {
        let url = "partwearout/uniqueDescriptions";
        return new Promise((resolve, reject) => {
            httpClient
                .get<any>(url, { params: params, signal: signal })
                .then((response: any) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }
        fetchDescriptionStats(params: any, signal: any): Promise < any > {
            let url = "partwearout/descriptionStats";
            return new Promise((resolve, reject) => {
                httpClient
                    .get<any>(url, { params: params, signal: signal })
                    .then((response: any) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        }

}


export const Api = new PartwearoutApi();